import type { Dispatch } from 'redux';
import DeleteModal from '@atlassian/jira-delete-filters-modal/src/index.tsx';
import type { OperationModalProps } from '@atlassian/jira-directory-base/src/model/index.tsx';
import type { Filter } from '@atlassian/jira-filters-common/src/model/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { type Action, deleted, deleteFailed } from '../../../state/actions/operations/index.tsx';
import { getFilter } from '../../../state/selectors/filters/index.tsx';
import type { State } from '../../../state/types.tsx';

const mapStateToProps = (state: State, ownProps: OperationModalProps<Filter>) => ({
	filter: getFilter(state, ownProps.entityId),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OperationModalProps<Filter>) => ({
	onInitialised: ownProps.onDialogShown,
	onFilterDeleted: (filter: Filter): void => {
		dispatch(deleted(filter.name));
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
		ownProps.onUpdated();
	},
	onFilterDeleteFailed: (filter: Filter) => dispatch(deleteFailed(filter.name)),
	onFilterInitiateFailed: (filter: Filter) => {
		dispatch(deleteFailed(filter.name));
		ownProps.onDataRetrieveFailed();
	},
	onCancel: ownProps.onCancel,
});

// @ts-expect-error - TS2345 - Type 'undefined' is not assignable to type 'Filter'.
export default connect(mapStateToProps, mapDispatchToProps)(DeleteModal);
